'use strict';

namespace Core {

    export class SeoKnowledgeGraph {
        constructor(
            private $scope: ng.IScope,
            private $sce: ng.ISCEService,
            private $filter: ng.IFilterService,
            private $window: ng.IWindowService,
            private $location: ng.ILocationService,
            private $element: JQuery,
        ) {
            const vm = this;

            function checkValue(value: any) {
                if (!value) { return; }
                const excludeStr = 'SEO_STUCTUREDDATA';
                const validValue = (value && value.includes(excludeStr)) ? '' : value;
                return (validValue) ? validValue : null;
            }

            function setJson(value) {
                return vm.$sce.trustAsHtml(vm.$filter('json')(value));
            }

            const showStructuredData  = TRPCONFIG.Domain2.ShowJsonLdHomepage;

            if (!showStructuredData) { return; }
            const el = vm.$element[0];

            const activate = () =>  {
                const baseUrl = $location && $location.absUrl();
                const addressLocality = checkValue($scope.addressLocality);
                const postalCode = checkValue($scope.postalCode);
                const streetAddress = checkValue($scope.streetAddress);
                const addressCountry = checkValue($scope.addressCountry);
                const imagePath = checkValue($scope.logoPath);
                const image = `${baseUrl}${imagePath}`;
                const logo = image;
                const name = checkValue($scope.name);
                const telephone = checkValue($scope.telephone);
                const contactType = checkValue($scope.contactType);
                const url = baseUrl;
                const socialNetworks = checkValue($scope.socialNetworks);
                const sameAs = (socialNetworks) ? socialNetworks.replace(/\r?\n|\r/g, '').split(',') : null;
                const schemaType = checkValue($scope.schemaType);

                const address = {
                    addressLocality,
                    streetAddress,
                    postalCode,
                    addressCountry,
                    image
                };

                const contactPoint = {
                    telephone,
                    contactType
                };

                const generic = {
                    logo,
                    sameAs,
                    name,
                    url
                };

                const addressCompacted = _.pickBy(address, (value: any) => value);
                const contactPointCompacted = _.pickBy(contactPoint, (value: any) => value);
                const genericCompacted = _.pickBy(generic, (value: any) => value);

                const ldJson = {
                    '@context': 'http://schema.org',
                    '@type': schemaType,
                    ...genericCompacted,
                    'address': {
                        '@type': 'PostalAddress',
                        ...addressCompacted
                    },
                    'contactPoint': {
                        '@type': 'ContactPoint',
                        ...contactPointCompacted
                    }
                };

                vm.$scope.ldJson = ldJson;
            };

            vm.$scope.$on('$routeChangeSuccess', function() {
                const homepage = $location.path();
                if (homepage !== '/') {
                    el.innerHTML = '';
                } else {
                    el.innerHTML = setJson(vm.$scope.ldJson);
                }
                activate();
            });
        }

        private onGetJson() {
            const path = this.$location.path();
           if  (path !== '/')  { return; }
           return this.$sce.trustAsHtml(this.$filter('json')(this.$scope.ldJson));
        }
    }
    angular
        .module('core')
        .directive('seoKnowledgeGraph', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {
                    addressLocality: '=',
                    postalCode: '=',
                    streetAddress: '=',
                    addressCountry: '=',
                    name: '=',
                    telephone: '=',
                    socialNetworks: '=',
                    contactType: '=',
                    logoPath: '=',
                    schemaType: '=',
                },
                controller: SeoKnowledgeGraph,
                controllerAs: 'spr',
                replace: true,
                bindToController: {
                    ld: '=',
                },
                template: () =>
                '<script id="knowledge-graph" type="application/ld+json" ng-bind-html="spr.onGetJson()"></script>',
            };

        });

}
